import React from "react";

class RadioCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: this.props.value || null,
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(optionValue, checked, id) {
        let selectedValue = this.state.selectedValue;
        const radioButton = document.getElementById(id);

        if (selectedValue && selectedValue === optionValue && checked) {
            radioButton.checked = false;
            selectedValue = null;
        } else {
            selectedValue = optionValue;
        }

        this.setState({ selectedValue });
        this.props.onChange(selectedValue);
    }

    render() {
        const { options, keyName } = this.props;
        if (!options || options.length === 0) {
            return "";
        }

        return (
            <div className="flex flex-row flex-wrap gap-4" key={keyName}>
                {options.map((option, index) => {
                    return (
                        <div className="flex items-center gap-2 pt-2" key={index}>
                            <input type="radio"
                                id={`radio-${index}-${keyName}`}
                                name={keyName}
                                defaultChecked={this.state.selectedValue === option.value}
                                onClick={(e) => this.onChange(option.value, e.target.checked, `radio-${index}-${keyName}`)}
                                className="checked:bg-primary-50 h-4 w-4 text-primary-50 border-gray-300 accent-primary-500 cursor-pointer"
                            />
                            <span className="text-sm">
                            {option.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default RadioCheckbox;